import type { NavRoutesConfig } from "#app/_ui/components/headers/nav-routes-config";

import filterHelper from "./filterHelper";
import type { NavRoutesConfigFilterParams } from "./filterNav";

export default function finPlanningNavFilter({
  navRoutesConfig,
  requiredData,
}: NavRoutesConfigFilterParams): NavRoutesConfig {
  let filtering = filterHelper(navRoutesConfig);

  if (!requiredData.canUseFinancialPlanning) {
    filtering = filtering.removeRouteSubById(
      "ThreeSixtyWealthAndPlanning",
      "PlanningOverview",
    );
  }

  if (!(requiredData.canUseFinancialPlanning && requiredData.hasVisiblePlans)) {
    filtering = filtering.removeRouteSubById(
      "ThreeSixtyWealthAndPlanning",
      "PlanningMyPlan",
    );
  }

  return filtering.getFilteredRoutesConfig();
}
